"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.find = exports.lstat = exports.readdir = void 0;
const fs_1 = require("fs");
const path_1 = require("path");
const common_1 = require("./common");
const debug_1 = require("./debug");
const extract_1 = require("./extract");
const minimatch = require("minimatch");
exports.readdir = fs_1.promises.readdir, exports.lstat = fs_1.promises.lstat;
async function find(src, excludePatterns = []) {
    const fileResults = [];
    const archiveResults = [];
    const handler = async (path, stats) => {
        if (!common_1.isSupportedSize(stats.size)) {
            return;
        }
        if (extract_1.isArchive(path)) {
            archiveResults.push(path);
            return;
        }
        fileResults.push(path);
    };
    const isExcluded = (path) => {
        return !!excludePatterns.find((pattern) => minimatch(path, pattern));
    };
    await traverse(src, handler, isExcluded);
    return [fileResults, archiveResults];
}
exports.find = find;
async function traverse(src, handle, isExcluded) {
    try {
        if (isExcluded(src)) {
            return;
        }
        const stats = await exports.lstat(src);
        if (stats.isSymbolicLink()) {
            return;
        }
        if (stats.isFile()) {
            handle(src, stats);
            return;
        }
        if (stats.isDirectory()) {
            const entries = await exports.readdir(src);
            for (const entry of entries) {
                const absolute = path_1.join(src, entry);
                await traverse(absolute, handle, isExcluded);
            }
        }
    }
    catch (error) {
        debug_1.debug(error.message || `Error reading file ${src}. ${error}`);
    }
}
//# sourceMappingURL=find.js.map